import { useEffect } from 'react';
import { connectSocket } from 'socket';

import { customToast } from '@components/widgets/toast/useToast';

import useGetCurrentUser from './useGetCurrentUser';

interface SocketNotification {
    title?: string;
    message: string;
    date?: string;
}

// keeps a websocket connection open and shows incoming notifications as toasts;
// reconnects with the new token on login / logout
export default function useSocketNotifications() {
    const { token } = useGetCurrentUser() || {};

    useEffect(
        () =>
            connectSocket(token, (notification: SocketNotification) => {
                customToast.info(notification.message);
            }),
        [token],
    );
}
